import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchDocumentHistory } from "../../../store/documentShow/actions/fetchDocumentHistory";
import findDocument from "../../../store/documentShow/actions/findDocument";
import { findSigners } from "../../../store/documentShow/actions/findSigners";
import findUsers from "../../../store/users/actions/findUsers";

export const ParamsWatcher: React.FC = () => {
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();

  useEffect(() => {
    dispatch(findDocument(id));
    dispatch(findSigners(id));
    dispatch(fetchDocumentHistory(id));
    
      dispatch(findUsers());
  }, [dispatch, id]);
  return <></>;
};
